import { SVGProps } from 'react';

export const CloudIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M13.702 19.647c-5.284.722-9.369 5.204-9.369 10.686 0 5.982 4.852 10.833 10.834 10.833H39a8.667 8.667 0 0 0 0-17.333c0-7.18-5.82-13-13-13-5.713 0-10.554 3.69-12.298 8.814Z'
      clipRule='evenodd'
    />
  </svg>
);
